if($('.accordion-container').length) {

    $('.accordion-container').each(function () {

        let accordionItems = $(this).find('.accordion-item'),
            accordionItemHeaders = $(this).find('.accordion-header');

        accordionItems.first().addClass('active');
        accordionItems.first().find('.accordion-body').slideDown();

        accordionItemHeaders.on('click', function () {
            let accordionItem = $(this).parent('.accordion-item'),
                accordionItemContent = accordionItem.find('.accordion-body');

            if(accordionItem.hasClass('active')) {
                accordionItem.removeClass('active');
                accordionItemContent.slideUp();
            } else {
                accordionItem.addClass('active');
                accordionItemContent.slideDown();
                accordionItems.not(accordionItem).removeClass('active');
                accordionItems.not(accordionItem).find('.accordion-body').slideUp();
            }
        });

    });

}
